import * as palette from "../palette";

import React from "react";

export default function InlineToolbarSeparator() {
  return (
    <div
      css={{
        height: 30,
        width: 1,
        opacity: 0.5,
        backgroundColor: palette.darkGray,
        userSelect: "none",
        cursor: "initial",
      }}
    />
  );
}
